import React from 'react'
import {Icon} from '@chakra-ui/react'

const FiltersIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                d="M10 10.917C10.4142 10.917 10.75 11.2528 10.75 11.667C10.7499 12.0811 10.4141 12.417 10 12.417H6C5.58587 12.417 5.25013 12.0811 5.25 11.667C5.25 11.2528 5.58579 10.917 6 10.917H10ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41421 12.4142 8.75 12 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H12ZM13.666 3.58301C14.0801 3.58301 14.4159 3.91891 14.416 4.33301C14.416 4.74722 14.0802 5.08301 13.666 5.08301H2.33301C1.91896 5.08281 1.58301 4.7471 1.58301 4.33301C1.58314 3.91903 1.91904 3.58321 2.33301 3.58301H13.666Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default FiltersIcon
